module.exports = __webpack_public_path__ + "static/7m-cd4ef8421683c708a619179dfb3cfa0a.jpg";